export default "__VITE_ASSET__DrHKduV8__"